<script setup>
import { ref, watch } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { POLITICAL_ROLES } from '../../socialMonitoring/utils/politicalRoles.js';

const props = defineProps({
  open: { type: Boolean, default: false },
  profile: { type: Object, default: null },
  saving: { type: Boolean, default: false },
});
const emit = defineEmits(['close', 'save']);

const form = ref({
  pageUrl: '',
  name: '',
  platform: 'facebook',
  type: 'target',
  politicalRole: '',
});

watch(
  () => props.profile,
  value => {
    if (value) {
      form.value = {
        pageUrl: value.fbId || '',
        name: value.name || '',
        platform: value.platform || 'facebook',
        type: value.type || 'target',
        politicalRole: value.politicalRole || '',
        id: value.id,
      };
    } else {
      form.value = {
        pageUrl: '',
        name: '',
        platform: 'facebook',
        type: 'target',
        politicalRole: '',
      };
    }
  },
  { immediate: true }
);

const submit = () => {
  emit('save', { ...form.value });
};
</script>

<template>
  <div
    v-if="open"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    @click.self="emit('close')"
  >
    <div class="w-full max-w-md rounded-xl bg-n-background">
      <div class="flex items-center justify-between border-b border-n-weak p-4">
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ profile ? 'Editar perfil' : 'Adicionar perfil' }}
        </h3>
        <Button
          variant="ghost"
          size="sm"
          icon="i-lucide-x"
          @click="emit('close')"
        />
      </div>
      <form class="space-y-3 p-4" @submit.prevent="submit">
        <div>
          <label class="mb-1 block text-xs font-medium text-n-slate-12"
            >Nome</label
          >
          <input
            v-model="form.name"
            type="text"
            required
            class="h-9 w-full rounded-lg border border-n-weak bg-n-background px-3 text-sm"
          />
        </div>
        <div>
          <label class="mb-1 block text-xs font-medium text-n-slate-12"
            >URL do perfil</label
          >
          <input
            v-model="form.pageUrl"
            type="text"
            required
            placeholder="https://facebook.com/pagina"
            class="h-9 w-full rounded-lg border border-n-weak bg-n-background px-3 text-sm"
          />
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label class="mb-1 block text-xs font-medium text-n-slate-12"
              >Plataforma</label
            >
            <select
              v-model="form.platform"
              class="h-9 w-full rounded-lg border border-n-weak bg-n-background px-2 text-sm"
            >
              <option value="facebook">Facebook</option>
              <option value="instagram">Instagram</option>
              <option value="tiktok">TikTok</option>
              <option value="twitter">Twitter/X</option>
            </select>
          </div>
          <div>
            <label class="mb-1 block text-xs font-medium text-n-slate-12"
              >Tipo</label
            >
            <select
              v-model="form.type"
              class="h-9 w-full rounded-lg border border-n-weak bg-n-background px-2 text-sm"
            >
              <option value="target">Alvo</option>
              <option value="competitor">Competidor</option>
            </select>
          </div>
        </div>
        <div>
          <label class="mb-1 block text-xs font-medium text-n-slate-12"
            >Cargo político</label
          >
          <select
            v-model="form.politicalRole"
            class="h-9 w-full rounded-lg border border-n-weak bg-n-background px-2 text-sm"
          >
            <option value="">Não informado</option>
            <option
              v-for="role in POLITICAL_ROLES"
              :key="role.value"
              :value="role.value"
            >
              {{ role.label }}
            </option>
          </select>
        </div>
        <div class="flex justify-end gap-2 pt-2">
          <Button
            variant="ghost"
            size="sm"
            type="button"
            @click="emit('close')"
          >
            Cancelar
          </Button>
          <Button
            variant="solid"
            color="blue"
            size="sm"
            type="submit"
            :is-loading="saving"
          >
            {{ profile ? 'Salvar' : 'Adicionar' }}
          </Button>
        </div>
      </form>
    </div>
  </div>
</template>
